export function planLayoutKey(planId) {
  return `plan-${planId}`;
}

export function collectNavIdsFromLayout(layout) {
  if (!Array.isArray(layout)) return [];
  const out = [];
  const walk = (nodes) => {
    for (const node of nodes) {
      if (!node || typeof node !== 'object') continue;
      if (node.kind === 'link' && node.navId) out.push(String(node.navId));
      if (node.kind === 'group' && Array.isArray(node.children)) walk(node.children);
    }
  };
  walk(layout);
  return out;
}

export function layoutFromNavIds(navIds) {
  return (navIds || [])
    .filter(Boolean)
    .map((navId) => ({ kind: 'link', navId: String(navId) }));
}
